import React from 'react';
import { Check, X } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function WhoIsItFor() {
  const isFor = ['Padres de niños de 8 a 12 años que sufren burlas, exclusión o acoso verbal.', 'Madres que sienten que el colegio minimiza el problema.', 'Niños que han empezado a perder la confianza y no quieren ir a clase.', 'Familias que buscan una solución táctica, rápida y sin violencia.'];
  const isNotFor = ['Casos de violencia física grave que requieren intervención policial inmediata.', 'Padres que buscan una solución mágica sin involucrarse en el proceso de su hijo.', "Personas que creen que el bullying es 'necesario para formar el carácter'."];
  return <section className="py-24 md:py-32 bg-offwhite-dark" data-id="element-490">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl" data-id="element-491">
        <FadeIn data-id="element-492">
          <div className="text-center mb-16" data-id="element-493">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-navy mb-4" data-id="element-494">
              ¿Es este protocolo para ti?
            </h2>
            <div className="w-24 h-1 bg-amber mx-auto rounded-full" data-id="element-495"></div>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-12" data-id="element-496">
          {/* Para quién es */}
          <FadeIn delay={0.1} data-id="element-497">
            <div className="bg-white p-8 md:p-10 rounded-3xl shadow-sm border-t-4 border-teal h-full" data-id="element-498">
              <h3 className="text-2xl font-bold text-navy mb-8 flex items-center gap-3" data-id="element-499">
                <div className="w-10 h-10 rounded-full bg-teal/10 flex items-center justify-center text-teal" data-id="element-500">
                  <Check size={20} className="stroke-[3]" data-id="element-501" />
                </div>
                Para quién SÍ es
              </h3>

              <ul className="space-y-6" data-id="element-502">
                {isFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-503">
                    <Check className="text-teal flex-shrink-0 mt-1" size={20} data-id="element-504" />
                    <span className="text-navy/80 leading-relaxed" data-id="element-505">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Para quién NO es */}
          <FadeIn delay={0.2} data-id="element-506">
            <div className="bg-white p-8 md:p-10 rounded-3xl shadow-sm border-t-4 border-red-500 h-full" data-id="element-507">
              <h3 className="text-2xl font-bold text-navy mb-8 flex items-center gap-3" data-id="element-508">
                <div className="w-10 h-10 rounded-full bg-red-50 flex items-center justify-center text-red-500" data-id="element-509">
                  <X size={20} className="stroke-[3]" data-id="element-510" />
                </div>
                Para quién NO es
              </h3>

              <ul className="space-y-6" data-id="element-511">
                {isNotFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-512">
                    <X className="text-red-500 flex-shrink-0 mt-1" size={20} data-id="element-513" />
                    <span className="text-navy/80 leading-relaxed" data-id="element-514">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}